export default __webpack_public_path__ + "static/media/empty-hourglass.f011ea35.png";